import { render, staticRenderFns } from "./kodetransaksitabungan.vue?vue&type=template&id=fa80f576&scoped=true&"
import script from "./kodetransaksitabungan.vue?vue&type=script&lang=js&"
export * from "./kodetransaksitabungan.vue?vue&type=script&lang=js&"
import style0 from "./kodetransaksitabungan.vue?vue&type=style&index=0&id=fa80f576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa80f576",
  null
  
)

export default component.exports